module.exports = __webpack_public_path__ + "img/business-3.d88c762e.png";